import * as CubiqTS from "shared/cubiq-model-multi-asset";
import * as CubiqServices from "shared/cubiq-services";
import { BfxApplicationNotificationCommand } from "./bfx-application-notification-command.enum";
import { Subject, Observable } from "rxjs";
import { BFXAppNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXAppNotificationType";
import { BFXAppNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXAppNotificationSubType";
import { BFXAppNotificationEventType } from "../../../shared/cubiq-services/model/core/notifications/BFXAppNotificationEventType";

export const NOTIF_SORT: any = (a, b) => {
  if (b.time == a.time) {
    if (a.eventType == b.eventType) {
      return 0;
    } else if (a.eventType == BFXAppNotificationEventType.DEAL_UPDATE_EVENT) {
      return -1;
    } else if (b.eventType == BFXAppNotificationEventType.DEAL_UPDATE_EVENT) {
      return 1;
    }
  }
  return b.time - a.time;
};

export class BfxApplicationNotificationData {
  public title: string;
  public time: number;
  public actions: Array<{
    label: string;
    command: BfxApplicationNotificationCommand;
    icon: string;
    styleClass: string;
  }>;
  public body: string;
  public bodyType: string;
  public footer: string;
  public footerAction: BfxApplicationNotificationCommand;
  public typeStr: string;
  public payload: Array<any> = [];
  public payloadIds: Array<string> = [];
  public payloadRefs: Array<string> = [];
  private notifApplicationCommandSubject: Subject<{
    command: BfxApplicationNotificationCommand;
    appData: BfxApplicationNotificationData;
  }> = new Subject<{
    command: BfxApplicationNotificationCommand;
    appData: BfxApplicationNotificationData;
  }>();

  public eventType: BFXAppNotificationEventType;

  constructor(
    public type: BFXAppNotificationType,
    public iconClassName: string = "icon-notification",
    public subType: BFXAppNotificationSubType = undefined,
    public idField = "orderId",
  ) {
    this.typeStr = BFXAppNotificationType[type];
    if (subType != undefined) {
      this.typeStr += "_" + BFXAppNotificationSubType[subType];
    }
  }

  subscribeForCommand(): Observable<{
    command: BfxApplicationNotificationCommand;
    appData: BfxApplicationNotificationData;
  }> {
    return this.notifApplicationCommandSubject.asObservable();
  }

  destroy() {
    this.payload = null;
    this.payloadIds = null;
    this.notifApplicationCommandSubject.complete();
  }

  doAction(command: BfxApplicationNotificationCommand, itemId?: string): void {
    if (itemId) {
      let itemIndex: number = this.payloadIds.indexOf(itemId.toString());
      if (itemIndex > 0) {
        let tempItem: string = this.payloadIds[0];
        this.payloadIds[0] = itemId.toString();
        this.payloadIds[itemIndex] = tempItem;
      }
    }
    this.notifApplicationCommandSubject.next({
      command: command,
      appData: this,
    });
  }

  addToPayload(item: any) {
    if (this.payloadIds.indexOf(item[this.idField]) == -1) {
      this.payload.push(item);
      this.payloadIds.push(item[this.idField]);
    }
  }

  removeFromPayload(itemId: any) {
    let idx: number = this.payload.findIndex((item) => item[this.idField] === itemId);
    if (idx > -1) {
      this.payload.splice(idx, 1);
    }
    idx = this.payloadIds.indexOf(itemId);
    if (idx > -1) {
      this.payloadIds.splice(idx, 1);
    }
  }
}
